/** 地面ブロックの高さ（px） */
export const GROUND_HEIGHT = 56;
